/** Must match Vedify-Backend/constants/dashboardModuleTags.js */
export const DASHBOARD_MODULE_TAGS = ['epic_series', 'shlokas', 'podcasts', 'rituals_puja'];

export const DASHBOARD_MODULE_TAG_OPTIONS = [
  { value: 'epic_series', label: 'Epic series' },
  { value: 'shlokas', label: 'Shlokas' },
  { value: 'podcasts', label: 'Podcasts' },
  { value: 'rituals_puja', label: 'Rituals & puja' },
];

export const toggleDashboardModuleTag = (tags, tag) => {
  const current = Array.isArray(tags) ? tags : [];
  return current.includes(tag) ? current.filter((item) => item !== tag) : [...current, tag];
};

export const dashboardModuleTagLabel = (tag) =>
  DASHBOARD_MODULE_TAG_OPTIONS.find((option) => option.value === tag)?.label || tag;
